// store.js

import { combineReducers, configureStore } from "@reduxjs/toolkit";
import addUserReducer from "../reducer/AddUserReducer";
import authReducer from "../redux/features/authSlice";
import DriveMasterReducer from "../reducer/DriveMasterReducer";
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";
import listUserSlice from "./features/listUserSlice";
import locationMasterReducer from "../redux/features/location-master/addLocationMasterSlice";
import locationMasterListSlice from "../redux/features/location-master/listLocationMasterSlice";
import locationMasterSingleListSlice from "../redux/features/location-master/singleListLocationMasterSlice";
import fleetMasterReducer from "./features/fleetMaster";
import driverMasterReducer from "./features/driverMaster";
import customerMasterReducer from "./features/customerMaster";
import laneMasterReducer from "./features/laneMaster";
import helperReducer from "./features/helperSlice";
import helperMasterReducer from "./features/helperMaster";
import vendorMasterReducer from "./features/vendorMaster";
import contractorMasterAddSlice from "./features/contractor-master/contractorMasterAddSlice";
import contractorMasterListSlice from "./features/contractor-master/contractorMasterListSlice";
import singleContractorContactDetailsSlice from "./features/contractor-master/singleContractorContactDetailsSlice";
import contractorMasterReducer from "./features/contractorMasterSlice";
import adhocLaneReducer from "./features/adhocLaneSlice";
import tripReducer from "./features/tripSlice";

import adhocTripReducer from "./features/adhocTripSlice";

import createActualReducer from "./features/createActualSlice";

const rootReducer = combineReducers({
   addUser: addUserReducer,
   listUser: listUserSlice,
   auth: authReducer,
   driveMaster: DriveMasterReducer,
   locationMasterReducer: locationMasterReducer,
   locationMasterListSlice: locationMasterListSlice,
   locationMasterSingleListSlice: locationMasterSingleListSlice,
   fleetMaster: fleetMasterReducer,
   driverMaster: driverMasterReducer,
   customerMaster: customerMasterReducer,
   laneMaster: laneMasterReducer,
   helper: helperReducer,
   helperMaster: helperMasterReducer,
   vendorMaster: vendorMasterReducer,
   contractorMasterAddSlice: contractorMasterAddSlice,
   contractorMasterListSlice: contractorMasterListSlice,
   singlecontractorContactDetailsSlice: singleContractorContactDetailsSlice,
   contractorMaster: contractorMasterReducer,
   trip: tripReducer,
   adhocLane: adhocLaneReducer,

   adhocTrip: adhocTripReducer,

   createActual: createActualReducer,
});

const persistConfig = {
   key: "root",
   storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
   reducer: persistedReducer,
});
export const persistor = persistStore(store);

export default store;
